import { Control } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export interface NumberInputProps {
  control: Control<any>;
  name: string;
  label?: string;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  suffixText?: string;
  disabled?: boolean;
}

const NumberInput = ({
  control,
  name,
  placeholder,
  min = 0,
  max,
  step,
  className,
  suffixText,
  disabled,
}: NumberInputProps) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <div className="relative">
              <Input
                type="number"
                min={min}
                max={max}
                step={step}
                placeholder={placeholder}
                disabled={disabled}
                onChange={e => {
                  const value = e.target.value;
                  // Handle empty string as min value (usually 0), otherwise convert to number
                  if (value === '') {
                    field.onChange(min);
                  } else {
                    const numValue = Number(value);
                    if (isNaN(numValue)) {
                      field.onChange(min);
                    } else if (max !== undefined && numValue > max) {
                      field.onChange(max);
                    } else {
                      field.onChange(numValue);
                    }
                  }
                }}
                onFocus={e => {
                  // Select all text on focus so user can immediately type to replace
                  e.target.select();
                }}
                value={
                  field.value === undefined || field.value === null ? '' : field.value.toString()
                }
                className={cn(
                  '[-moz-appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
                  className
                )}
              />
              {suffixText && (
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
                  {suffixText}
                </span>
              )}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default NumberInput;
